export default { 
  SET_ROWS(state, payload){
    state.rows = payload || []
  },
  SET_ROW(state, payload){
    state.row = payload || null
  },
};
